/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Temperature } from './Temperature';
import {
    instanceOfTemperature,
    TemperatureFromJSON,
    TemperatureFromJSONTyped,
    TemperatureToJSON,
} from './Temperature';

/**
 * @type AnalysisResultDtoMeanAirTemperature
 * 
 * @export
 */
export type AnalysisResultDtoMeanAirTemperature = Temperature;


export function AnalysisResultDtoMeanAirTemperatureFromJSON(json: any): AnalysisResultDtoMeanAirTemperature {
    return AnalysisResultDtoMeanAirTemperatureFromJSONTyped(json, false);
}

export function AnalysisResultDtoMeanAirTemperatureFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisResultDtoMeanAirTemperature {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...TemperatureFromJSONTyped(json, true) };
    return  TemperatureFromJSONTyped(json, true);
}

export function AnalysisResultDtoMeanAirTemperatureToJSON(value?: AnalysisResultDtoMeanAirTemperature | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfTemperature(value)) {
        return TemperatureToJSON(value as Temperature);
    }

    return {};
}

/**
 * Check if a given object implements the AnalysisResultDtoMeanAirTemperature interface.
 */
export function instanceOfAnalysisResultDtoMeanAirTemperature(value: any): value is AnalysisResultDtoMeanAirTemperature {
    if (instanceOfTemperature(value)) return true;
    return false;
}

